// import psyImages from "../components/utility/psychologicalImageImports";
const vacationChoicesRo = [
  {
    label:
      "Un refugiu liniștit într-un spa minimalist, gri cu peșteri misterioase în apropiere.",

    value:
      'A quiet retreat in a minimalist, gray spa with mysterious caves nearby.{"Gray":"3","Black":"2"}',
    // imageUrl: psyImages["vacation/forFormA.png"],
  },
  {
    label: "O plajă liniștită cu ape azurii și amurg pe cer.",
    value:
      'A serene beach with azure waters and twilight in the sky.{"Blue":"3","Violet":"2"}',
    // imageUrl: psyImages["vacation/forFormB.png"],
  },

  {
    label: "O pădure luxuriantă cu copaci verzi înalți și căi pământii maro.",
    value:
      'A lush green forest with tall green trees and earthy brown paths.{"Green":"3","Brown":"2"}',
    // imageUrl: psyImages["vacation/forFormC.png"],
  },

  {
    label: "Un oraș aglomerat cu viață de noapte intensă și parcuri deschise, însorite.",
    value:
      'A bustling city with intense nightlife and sunny, open parks.{"Red":"3","Yellow":"2"}',
    // imageUrl: psyImages["vacation/forFormD.png"],
  },
];

export default vacationChoicesRo;
